// extracted by mini-css-extract-plugin
export default {"helpdeskAnchorContainer":"styles_helpdeskAnchorContainer__D70pH","helpButton":"styles_helpButton__rzajm","helpIcon":"styles_helpIcon__dbfJC"};